import React from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import { useDispatch } from "react-redux";
import { startActivityFromTrainingAction } from "@icarius-pages/myTraining/actions";
import { getLocalizedString } from "@icarius-localization/strings";
import Container from "../../../container";

const StartCountdown = ({ trainingData, activityData }) => {
    const dispatch = useDispatch();
    const color = useSelector(getAppColor);

    const handleStart = () => {
        dispatch(startActivityFromTrainingAction(trainingData.id, activityData.id));
    };

    if (!["E", "P"].includes(activityData.type) || activityData.isInPersonActivity) return null;

    return (
        <Container>
            <Grid container alignItems="center" direction="column">
                <Typography align="center" style={{ fontSize: 20 }}>
                    {getLocalizedString("thisActivityHasLengthOf")}{" "}
                    <b>
                        {activityData.length} {getLocalizedString("hrs")}
                    </b>
                    .
                </Typography>
                <Typography align="center" style={{ margin: "15px 80px" }}>
                    {getLocalizedString("activityCountdownExplanation1")}
                </Typography>
                <Typography align="center" style={{ marginBottom: 15 }}>
                    {getLocalizedString("activityCountdownExplanation2")}
                </Typography>
                <Button
                    variant="contained"
                    className="whiteText"
                    style={{ background: color, border: 0 }}
                    onClick={handleStart}
                >
                    {`${getLocalizedString("startActivity")} (${getLocalizedString("attempt")} ${
                        activityData.currentAttempt
                    } ${getLocalizedString("of")} ${activityData.attempts})`}
                </Button>
            </Grid>
        </Container>
    );
};

export default StartCountdown;
